/**
 * @description 导出项目常量
 **/
const constants = {
  // 题型
  QUESTION_TYPE: [
    {
      label: "题型（全部）",
      value: "",
    },
    {
      label: "单选题",
      value: "single",
    },
    {
      label: "多选题",
      value: "multiple",
    },
    {
      label: "判断题",
      value: "truefalse",
    },
    {
      label: "填空题",
      value: "fill",
    },
    {
      label: "简答题",
      value: "essay",
    },
  ],
  // 题型难度
  QUESTION_LEVEL: [
    {
      id: 0,
      name: "难易度（全部）",
      key: "",
    },
    {
      id: 1,
      name: "易",
      key: "easy",
    },
    {
      id: 2,
      name: "中",
      key: "medium",
    },
    {
      id: 3,
      name: "难",
      key: "difficult",
    },
  ],
  // 考试状态
  EXAM_STATUS: [
    { label: "考试状态（全部）", value: "-1" },
    { label: "待开考", value: "0" },
    { label: "已开考", value: "1" },
    { label: "已结束", value: "2" },
  ],
};
module.exports = constants;
